import { gql } from '@apollo/client'

export const createApplicationMutation = gql`
  mutation createApplication(
    $application: Credit_BusinessCredit_CreateApplicationInput!
  ) {
    credit {
      businessCredit {
        createApplication(input: $application) {
          creditApplication {
            id
            countryCode
            referenceId
            creditProductIdentifier
            originationUrl
            status
            business {
              legalBusinessName
              phones {
                countryCode
                nationalNumber
                extensionNumber
                type
                primary
              }
              address {
                adminArea2
                adminArea1
                postalCode
                addressLine1
                countryCode
              }
              incorporationRegion
              organizationType
            }
            device {
              clientIpAddress
            }
            loanPurpose
            guarantor {
              emailAddress
              phones {
                countryCode
                nationalNumber
                extensionNumber
                type
                primary
              }
              name {
                givenName
                surname
              }
              address {
                countryCode
                addressLine1
                adminArea1
                adminArea2
                postalCode
              }
            }
            productDiscovery {
              source
              invitationCode
            }
            consents {
              type
              status
            }
            campaign {
              id
            }
          }
        }
      }
    }
  }
`

export const updateApplicationMutation = gql`
  mutation updateApplication(
    $updateInput: Credit_BusinessCredit_UpdateApplicationInput!
  ) {
    credit {
      businessCredit {
        updateApplication(input: $updateInput) {
          creditApplication {
            id
            countryCode
            referenceId
            creditProductIdentifier
            originationUrl
            status
            business {
              legalBusinessName
              phones {
                countryCode
                nationalNumber
                extensionNumber
                type
                primary
              }
              address {
                adminArea2
                adminArea1
                postalCode
                addressLine1
                countryCode
              }
              incorporationRegion
              organizationType
            }
            device {
              clientIpAddress
            }
            loanPurpose
            guarantor {
              emailAddress
              phones {
                countryCode
                nationalNumber
                extensionNumber
                type
                primary
              }
              name {
                givenName
                surname
              }
              address {
                countryCode
                addressLine1
                addressLine2
                adminArea1
                adminArea2
                postalCode
              }
            }
            productDiscovery {
              source
              invitationCode
            }
            consents {
              type
              status
            }
            campaign {
              id
            }
          }
        }
      }
    }
  }
`

export const submitApplicationMutation = gql`
  mutation submitApplication(
    $submitInput: Credit_BusinessCredit_SubmitApplicationInput!
  ) {
    credit {
      businessCredit {
        submitApplication(input: $submitInput) {
          applicationId
        }
      }
    }
  }
`
export const normalizeAddressMutation = gql`
  mutation normalizeAddress(
    $addressInput: Credit_BusinessCredit_NormalizeAddressInput!
  ) {
    credit {
      businessCredit {
        normalizeAddress(input: $addressInput) {
          status
          address {
            countryCode
            addressLine1
            addressLine2
            adminArea1
            adminArea2
            postalCode
          }
        }
      }
    }
  }
`
